import axios, { AxiosError, AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";

// export const apiInstance = axios.create({ baseURL: process.env.REACT_APP_API_URL });
export const apiInstance = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// export const callApiInstance = ({ url, method, data, responseType, headers, params }: AxiosRequestConfig) =>
//   apiInstance({ url, method: method || "GET", data, responseType, headers, params })
//     .then((response) => ({
//       data: response.data,
//       status: response.status
//     }))
//     .catch((error) => {
//       if (error instanceof AxiosError && error.response?.status === 401) {
//         Swal.fire({
//           title: "Session expired!",
//           text: "Please refresh the browser",
//           icon: "error",
//           confirmButtonText: "refresh",
//           allowOutsideClick: false
//         }).then(({ isConfirmed }) => {
//           if (!!isConfirmed) window.location.reload();
//         });
//         // window.location.reload();
//       }
//       return error;
//       // if (error.response && error.response.data) throw error.response.data;
//       // else throw new Error("Error from API Call");
//     });
export const callApiInstance = async ({ url, method, data, responseType, headers, params }: AxiosRequestConfig) => {
  try {
    const response = await apiInstance({ url, method: method || "GET", data, responseType, headers, params });

    return {
      data: response.data,
      status: response.status,
      ok: true
    };
  } catch (error: any) {
    const response = {
      data: error?.response?.data,
      status: error?.response?.status || 500,
      ok: false
    };

    if (error instanceof AxiosError && error.response?.status === 401) {
      Swal.fire({
        title: "Session expired!",
        text: "Please refresh the browser",
        icon: "error",
        confirmButtonText: "refresh",
        allowOutsideClick: false
      }).then(({ isConfirmed }) => {
        if (!!isConfirmed) window.location.reload();
      });
      // window.location.reload();
      return response;
    }

    return response;
  }
};
